import React from 'react';
import Myprofile from '../components/Myprofile';

const MyProfile = () => (
  <div>
    <Myprofile />
  </div>
);

export default MyProfile;
